import type { FaireProductEntity } from "../../entity_types/product";

export const p_dym5t64rcb: FaireProductEntity = {
  token: "p_dym5t64rcb",
  type: "product",
  name: '"Tocco" Tomato sauce with tuna from Liguria 180GR',
  brandToken: "b_p3mzzb85vs",
  brandName: "La Cascina di Marta",
  imageUrl:
    "https://cdn.faire.com/fastly/e62a9b5d984bfb32f55f87183b7acfe821a882dbaf3f332607cf129e2cd2d2cd.png",
  galleryImageUrls: [],
  priceDollars: 5.61,
  description:
    "This is a classic tomato sauce, ideal on spaghetti, to give them a tasteful flavour. Children love it, and you can use it all year round. It is a light main dish. Spaghetti are ideal but if you prefer to eat cold pasta, it is better to choose a short one. In packages of 180 g.",
  tags: [],
  msrpDollars: 11.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:19.241Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
